import { createGenericTypes, createGenericActions } from 'utils/createAction'

export const updateTalentProfileTypes = createGenericTypes(
  'UPDATE_TALENT_PROFILE'
)
export const updateTalentProfileActions = createGenericActions(
  updateTalentProfileTypes
)
